import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./api/apiConfig";

export interface PrescriptionItemRequest {
  medicamentId: number;
  quantity: number;
  dosage: string;
  frequency: string;
  route?: string;
  form?: string;
  startDate?: string;
  endDate?: string;
  specialInstructions?: string;
}

export interface PrescriptionRequest {
  doctorId: number;
  patientId: number;
  medicalRecordId: number;
  issueDate: string; // Format YYYY-MM-DD
  partZeroDetails?: string;
  partOneDetails?: string;
  partTwoDetails?: string;
  partThreeDetails?: string;
  instructions?: string;
  orderNumber?: string;
  items: PrescriptionItemRequest[];
}

class PrescriptionService {
  async createPrescription(prescriptionData: PrescriptionRequest) {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.PRESCRIPTIONS.BASE,
        prescriptionData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating prescription:", error);
      throw error;
    }
  }

  async getPrescriptionsByPatient(patientId: number) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.PRESCRIPTIONS.BY_PATIENT(patientId)}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching prescriptions:", error);
      throw error;
    }
  }
}

export const prescriptionService = new PrescriptionService();
